module.exports = __webpack_public_path__ + "static/qoute-4f67ca6510f4b2d6324b7b1b88b27e5a.png";